export default {
  state: {
    storageList: []
  },
  mutations: {
    setStorageList: (state, { list }) => {
      state.storageList = list
    }
  },
  actions: {}
}
